import type { CommandBody } from '../CrossOriginMessage';

/**
 * Indicates that the currenct section was expired.
 */
export class ExpiringSessionCommandBody implements CommandBody {}
